<template>
  <div class="fangQList">
    <topNav :title="$t('fangQ_title')"
            selfMethod="1"
            @leftClick="goBack"
            url="/fangQ"></topNav>

    <div class="search-bar" @click="openPick('picker')">
      <div class="search-bar-inner">
<!--        <span class="date-btn" @click="prev"><</span>-->
        {{ searchOption.beginDate | fdateF }}
<!--        <span class="date-btn" @click="next">></span>-->

      <span class="iconfont icon-you1"> </span>
      </div>
    </div>


    <mt-datetime-picker ref="picker"
                        type="date"
                        @confirm="handleConfirm"
                        :startDate="minDate"
                        :endDate="maxDate"
                        v-model="searchOption.beginDate"></mt-datetime-picker>

    <div class="table">
      <div class="spe-topd">
        <div class="topr">
          <table class="tbl"
                 style="background-color: #fff;font-weight:bold;"
                 v-if="dateRange.length > 0">
            <tr>
              <td style="height:1.5rem;width:1.6rem;" @click="openChoose">房型
                <span class="iconfont icon-ADown"></span>
              </td>
              <td style="height:1.5rem;width:1rem;">
                <div>房数</div>
                <div style="font-size: 12px;">{{getAllRmtypeNum()}}</div>
              </td>
            </tr>
          </table>
          <div class="gtt"
               id="theader">
            <table class="gant"
                   :style='{width:(dateRange.length * 1.04)+"rem"}'>
              <tr>
                <template v-for="(d,index) in dateRange">
                  <td :key="'dateRange-d' + index"
                      class="std h"
                      @click="changeDate(d)"
                      :class="{'speDay' :getWeekNum(d.d) == 5 || getWeekNum(d.d) == 6}">
                    <div class="normalDay" :class="{'activeDay': isSameDay(searchOption.beginDate, d.d)}">{{ d.d | dm2 }}</div>
                    <div style="font-size: 12px;">{{ d.d | getWeekText }}</div>
                    <div style="font-size: 12px;color: #cf6acf">
                      {{getAllNum(index)}}
                    </div>
                  </td>
                </template>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="list list2 clearfix gttab">
        <table class="tbl">
          <tr v-for='(item,index) in tabList'
              :class="{'hide' :!item.isActive}"
              :key="'tabList1' + index">
            <td style="text-align: left;padding-left: 3px;padding-right: 3px;">
              <span class="line" style="display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 2;
overflow: hidden;
text-overflow: ellipsis;">
              {{ item.descript }}</span>
            </td>
            <td style="width: 1rem">
              {{ item.rmtypeNum }}
            </td>
          </tr>
          <tr :class="{firstLine: index == 0, secondLine: index==7}"
              v-for="(item, index) in orderExtraTab"
              style="background: #fff"
              :key="'extra' + index">
            <td style="height: 1rem; text-align: left;padding-left: 3px;padding-right: 3px;font-weight:bold;color: #000!important;">
              {{ item.descript }}
            </td>
            <td style="width: 1rem;height: 1rem; ">
            </td>
          </tr>
        </table>
        <div class="gtt"
             id="tbody">
          <table class="gant"
                 :style='{width:(dateRange.length * 1.04)+"rem"}'>
            <tr v-for='(item,index) in tabList'
                :class="{'hide' :!item.isActive}"
                :key="'tabList2' + index">
              <template v-for="(item2,i2) in dateRange">
                <td :key="'dateRange-i2' + i2"
                    class="std" :class="{'speDayTD' :getWeekNum(item2.d) == 5 || getWeekNum(item2.d) == 6}">
                  <div class="width-fix">{{ distd(item2[item.rmtype]) }}</div>
                </td>
              </template>
            </tr>

            <tr  :class="{firstLine: index == 0, secondLine: index==7}"
                 v-for="(item, index) in orderExtraTab"
                 style="background: #fff"
                 :key="'extra' + index">
              <td :key="'extra-i2' + index"
                  v-for="(item2, index2) in 7"
                  style="height: 1rem; "
                  class="std">
                <div class="width-fix" style="color: #000;font-size: 0.25rem;">{{ item['day' + (index2 +1)] }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>


    <div class="type-select">
      <div class="select-item"
           @click="changeTypeItem(item)"
           :class="{active: item.code == type}"
           v-for="(item,index) in typeListArr"
           :key="index">
        {{ item.descript }}
      </div>
    </div>

    <div class="choose-modal" v-if="showChoose">
      <div class="choose-modal-main">
        <div class="choose-title">选择房型</div>
        <div class="choose-list">
          <div class="choose-item"
               v-for="(item, index) in tabList" :key="'ch-tab' + index"
               @click="toggleActive(item)"
               :class="{isActive: item.isActive}">
            <span class="check-box">√</span>
            {{ item.descript }}
          </div>
        </div>
        <div class="choose-footer">
          <div class="btn" @click="chooseAll">全选</div>
          <div class="btn" @click="reverseAll">反选</div>
          <div class="btn" @click="showChoose = false">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import json from "../../conf/datePick.js";
import {Toast} from "mint-ui";
import _ from "lodash";

export default {
  data() {
    return {
      showModal: false,
      searchOption: {
        beginDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(6, "d").format("YYYY-MM-DD"),
      },
      minDate: moment(moment().format("YYYY-MM-DD")).toDate(),
      minDate2: moment(moment().format("YYYY-MM-DD")).toDate(),
      maxDate: moment(moment().add(6, "M").format("YYYY-MM-DD")).toDate(),

      oldBegin: '',
      oldEnd: '',


      listData: [],
      dateRange: [],
      loading: false,
      time: moment().format("YYYY-MM-DD"),
      showType: 1,
      chartArr: [],
      tabList: [],
      orderList: [],

      // biz_date 日期 rmtype 房型代码 descript  房型描述 descript_en 房型英文描述 rmtype_num 房型数量 book_num 占用房数  ooo_num 维修房 os_num 锁房 arr_num 本日到房数  dep_num 本日离房数 rest_num 可卖房  rest_num2 可卖房（不含预离）
      typeList: {
        // rmtypeNum: '房型数量',
        restNum: '可售房',
        restNum2: '可售房（不含预离）',
        bookNum: '占用房数',
        oooNum: '维修房',
        osNum: '锁定房',
        arrNum: '本日到房数',
        depNum: '本日离房数',
      },

      typeListArr: [
        {code: 'restNum',descript: '可售房',},
        {code: 'restNum2',descript: '可售(不含预离)',},
        {code: 'bookNum',descript: '占用房',},
        {code: 'oooNum',descript: '维修房',},
        {code: 'osNum',descript: '锁定房',},
        {code: 'arrNum',descript: '本日到',},
        {code: 'depNum',descript: '本日离',},
      ],
      orderListExtra: [],
      orderExtraTab: [],
      type: localStorage.getItem('fangQListType') || 'restNum',
      openControlPanel: localStorage.getItem('openControlPanel') == 'yes',
      showChoose: false,
    };
  },
  mounted() {
    this.getData();
    // this.getExtraData();
    //监听该页面滚动条
  },

  methods: {
    getAllRmtypeNum(){
      var temp = 0
      this.tabList.map((item) => {
        if(item.isActive){
          temp += item.rmtypeNum
        }
      })
      return temp
    },
    getAllNum(indexOut){
      var temp = 0
      var self = this

      this.dateRange.map((item, index) => {
        if(indexOut == index){
          this.tabList.map((item2, index2) => {
            if(item2.isActive){
              if(item[item2.rmtype]){
                temp += item[item2.rmtype].title
              }
            }
          })
        }

      })

      return temp
    },
    toggleActive(item){
      item.isActive = !item.isActive
    },
    chooseAll(){
      this.tabList.map((item) => {
        item.isActive = true
      })
    },
    reverseAll(){
      this.tabList.map((item) => {
        item.isActive = !item.isActive
      })
    },
    openChoose() {
      this.showChoose = true
    },

    prev(){
      if(moment(this.searchOption.beginDate) > moment()){
        this.searchOption.beginDate =  moment(this.searchOption.beginDate).subtract(1, 'd').format("YYYY-MM-DD")
        this.searchOption.endDate =  moment(this.searchOption.beginDate).add(6, "d").format("YYYY-MM-DD")
        this.getData()
      } else {
        this.msg('不能再往前了')
      }
    },
    next(){
      this.searchOption.beginDate =  moment(this.searchOption.beginDate).add(1, 'd').format("YYYY-MM-DD")
      this.searchOption.endDate =  moment(this.searchOption.beginDate).add(6, "d").format("YYYY-MM-DD")
      this.getData()
    },

    changeTypeItem(item){
      var type = item.code
      this.type = type
      var d = moment(this.searchOption.beginDate).format("YYYY-MM-DD")
      var endDate = moment(this.searchOption.endDate).format("YYYY-MM-DD")
      var sp = {
        beginDate: d,
        endDate: endDate,
        showVal: type,
      }
      localStorage.setItem('fangQListType', type)
      this.setRange(sp);
    },
    changeType() {
      var d = moment(this.searchOption.beginDate).format("YYYY-MM-DD")
      var endDate = moment(this.searchOption.endDate).format("YYYY-MM-DD")
      var sp = {
        beginDate: d,
        endDate: endDate,
        showVal: this.type,
      }
      localStorage.setItem('fangQListType', this.type)
      this.setRange(sp);
    },

    openPick(p) {
      this.$refs[p].open();
    },

    handleConfirm(d) {
      this.searchOption.beginDate = moment(d).format(
        "YYYY-MM-DD"
      );this.searchOption.endDate = moment(this.searchOption.beginDate).add(6, 'd').format(
        "YYYY-MM-DD"
      );
      this.getData()
    },

    distd(data) {
      if (data) {
        var title = data.title;
        return title;
      }
      return "";
    },
    touchTd() {

    },
    goBack() {
      this.$router.go(-1);
    },

    changeDate(item){
      var date = item.d
      // beginDate: moment().format("YYYY-MM-DD"),
      //   endDate: moment().add(6, "d").format("YYYY-MM-DD"),
      this.searchOption.beginDate =  moment(date).format("YYYY-MM-DD")
      this.searchOption.endDate =  moment(date).add(6, "d").format("YYYY-MM-DD"),
      this.getData()
    },
    getData() {
      var d = moment(this.searchOption.beginDate).format("YYYY-MM-DD")
      var endDate = moment(this.searchOption.endDate).format("YYYY-MM-DD")
      this.$http.post("/mobilepmsapi/reception/getRoomSituationForReport", {
        d: d,
        endDate: endDate
      }).then(res => {
        if (res.data.result == 0) {
          this.orderList = res.data.retVal || [];
          this.setTabList()
          var sp = {
            beginDate: d,
            endDate: endDate,
            showVal: this.type,
          }
          this.setRange(sp);
          this.setscroll();
        } else {
          this.msg(res.data.msg);
        }
      });
    },
    getExtraData(){
      var d = moment(this.searchOption.beginDate).format("YYYY-MM-DD 00:00:00")
      this.$http.post("/mobilepmsapi/reception/findControlPanel", {
        beginDate: d,
      }).then(res => {
        if (res.data.result == 0) {
          var list = res.data.retVal || [];
          var temp = []

          var indexObj = {
            '本夜占用': 1,
            '本夜可用': 2,
            '维修房': 3,
            '锁定房': 4,
            '预计到达': 5,
            '预计离店':6,
            '出租率': 7,
            '平均房价': 8,
            '预计客房收入': 9,
          }

          list.map((item) => {
            item.isActive = true
            item.listOrder = indexObj[item.descript]
            if(item.descript == '出租率'){
              item.day1 = this.formatPercent(item.day1)
              item.day2 = this.formatPercent(item.day2)
              item.day3 = this.formatPercent(item.day3)
              item.day4 = this.formatPercent(item.day4)
              item.day5 = this.formatPercent(item.day5)
              item.day6 = this.formatPercent(item.day6)
              item.day7 = this.formatPercent(item.day7)
            }
            if(item.descript == '预计客房收入'){
              item.day1 = this.formatMoney(item.day1)
              item.day2 = this.formatMoney(item.day2)
              item.day3 = this.formatMoney(item.day3)
              item.day4 = this.formatMoney(item.day4)
              item.day5 = this.formatMoney(item.day5)
              item.day6 = this.formatMoney(item.day6)
              item.day7 = this.formatMoney(item.day7)
            }
          })

          list.sort((a, b) => a.listOrder - b.listOrder); //降序是b-a  [1, 5, 10, 25, 40, 100]
          this.orderExtraTab = list
          this.$forceUpdate()
        } else {
          this.msg(res.data.msg);
        }
      });
    },
    formatPercent(num){
      return (num * 100).toFixed(2) + '%'
    },
    formatMoney(num){
      if(num > 10000){
        return (num / 10000).toFixed(2) + 'w'
      } else {
        return num
      }
    },
    setTabList() {
      var orderList = this.orderList || []
      var arr = _.union(_.map(orderList, 'rmtype'))
      var final = []
      arr.map((item) => {
        var des = ''
        var rmtypeNum = ''
        orderList.map((item2) => {
          if (item2.rmtype == item) {
            des = item2.descript
            rmtypeNum = item2.rmtypeNum
          }
        })
        final.push({
          isActive: true,
          rmtype: item,
          descript: des,
          rmtypeNum: rmtypeNum,
        })
      })
      this.tabList = final

      if(this.openControlPanel){
        this.getExtraData()
      }
    },

    setscroll() {
      document.getElementById("tbody").addEventListener("scroll", this.bodyscroll);
      document.getElementById("theader").addEventListener("scroll", this.headscroll);
    },
    bodyscroll() {
      document.getElementById("theader").scrollLeft = document.getElementById("tbody").scrollLeft;
    },
    headscroll() {
      document.getElementById("theader").scrollLeft = document.getElementById("tbody").scrollLeft;
    },
    setRange(sp) {
      var start = moment(sp.beginDate).toDate().getTime();
      var end = moment(sp.endDate).add(1, "day").toDate().getTime();
      this.dateRange = [];
      while (start < end) {
        var p = {
          d: start
        };
        _.forEach(this.orderList, (el, key) => {
          var place = el.rmtype;
          var b = moment(el.bizDate).toDate().getTime();
          var isInDate = (b >= start) && (b <= (start + 86399999))
          if (isInDate) {
            if (p[place]) {
              p[place].title = el[sp.showVal]
            } else {
              p[place] = {
                title: el[sp.showVal]
              };
            }
          }
        });
        this.dateRange.push(p);
        start += 86400000; // +1天的时间
      }


      console.log('嘻嘻嘻嘻嘻',this.dateRange)
    },

    msg(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000
      });
    },
    getWeekNum(v) {
      return moment(v).day()
    },

    isSameDay(a,b){
      return moment(a).format("MM/DD") == moment(b).format("MM/DD")
    },
  },
  filters: {
    week(value) {
      return moment(value).day() == 0
        ? json.week[json.week.length - 1]
        : json.week[moment(value).day() - 1];
    },
    dateF(value) {
      return value != "" ? value.replace(/-/g, "/").substring(5, 10) : "";
    },
    fdate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    fdateF(value) {
      return moment(value).format("YYYY年MM月");
    },
    dm(v) {
      var weekarr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      return moment(v).format("MM/DD") // + weekarr[moment(v).day()];
    },
    dm2(v) {
      var weekarr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      return moment(v).format("D") // + weekarr[moment(v).day()];
    },
    getWeekText(v) {
      var weekarr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      return weekarr[moment(v).day()];
    },

  },
  beforeRouteLeave(to, from, next) {
    var e = document.getElementById("tbody");
    if (e) {
      e.removeEventListener("scroll", this.bodyscroll);
    }
    e = document.getElementById("theader");
    if (e) {
      e.removeEventListener("scroll", this.headscroll);
    }
    next();
  },
};
</script>

<style lang="less">
.fangQList {
  overflow: auto;

  .hide{
    height: 0 !important;
    display: none !important;
  }

  .choose-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);

    .choose-modal-main {
      position: absolute;
      width: 80%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 10px;

      .choose-title {
        text-align: center;
        font-size: 20px;
        border-bottom: 1px solid #ddd;
        padding: 15px;
      }

      .choose-list {
        max-height: 60vh;
        overflow-y: scroll;
        padding: 15px;
        box-sizing: border-box;

        .choose-item {
          display: flex;
          align-items: center;

          &:active {
            background: #ddd;
          }

          &.isActive {
            .check-box {
              background: green;
              color: #fff;
            }
          }

          .check-box {
            text-align: center;
            color: #fff;
            display: inline-block;
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 1px solid #ccc;
            border-radius: 5px;
            margin-right: 10px;
          }

          padding: 7px 15px;
          font-size: 16px;
          box-sizing: border-box;
        }
      }

      .choose-footer {
        display: flex;
        border-top: 1px solid #ddd;
        height: 50px;

        .btn {
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 16px;
          flex: 1;
          border-right: 1px solid #ddd;

          &:active {
            background: #ddd;
          }
        }
      }
    }
  }

  .speDay {
    //color: #ffff00 !important;
  }
  .normalDay{
    width: 24px;
    height: 24px;
    line-height: 20px;
    border-radius: 24px;
    text-align: center;
    margin: 0 auto;
    box-sizing: border-box;
    border: 2px solid #fff;
    &.activeDay{
      background: #428bca;
      border: 2px solid #b1e5e6;
      color: #fff;
    }
  }


  .search-bar {
    height: 45px;
    line-height: 45px;
    padding: 0 15px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;

    &:active{
      background: #eee;
    }


    .search-bar-inner{
      //position: absolute;
      //width: 100%;
    }
    .icon-you1{
      position: absolute;
      right: 15px;
      font-size: 30px!important;
    }
  }

  .type-select {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
border-top: 1px solid #eaeaea;
    background: #fff;
    .select-item{
      flex: 1;
      padding: 5px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active{
        color: #428bca;
        border-bottom: 5px solid  #428bca;
      }
    }

    select {
      display: inline-block;
      border-radius: 4px;
      border: 1px solid #eaeaea;
      height: 32px;
      line-height: 32px;
      padding: 0 5px;
      width: 100%;
    }
  }
  .signModal {
    .signModal-mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      background: rgba(0, 0, 0, 0.5);
    }

    .signModal-container {
      background: #fff;
      width: 80%;
      overflow: hidden;
      border-radius: 10px;
      position: fixed;
      top: 50%;
      left: 50%;
      padding-bottom: 15px;
      transform: translate(-50%, -50%);
      z-index: 11;

      .fliter_item {
        margin-top: 0.4rem;
        padding: 0 0.26666667rem;

        &:nth-last-of-type(2) .category_list {
          border-bottom: 1.33333333rem solid #fff;
          /*padding-bottom: 1.33333333rem;*/
        }

        .category_name {
          height: 0.33333333rem;
          margin: 0 0.26666667rem 0.06666667rem;

          span {
            font-size: 0.26666667rem;
            color: #9b9b9b;
          }
        }

        .category_list {
          padding: 0.26666667rem 0 0.13333333rem;
          border-bottom: 0.02666667rem solid #efefef;

          .option {
            font-size: 0.33333333rem;
            width: 1.6rem;
            margin: 0px 0.13333333rem 0.26666667rem;
            float: left;
            border-radius: 0.10666667rem;
            background-color: #efefef;
            color: #606060;
            text-align: center;
            line-height: 0.69333333rem;
            overflow: hidden;
            height: 0.69333333rem;
          }

          & .checked {
            background-color: #f98f3c;
            color: #fff;
          }

          &.twocol {
            .option {
              width: 2.53333333rem;
              color: #333333;
            }
          }
        }
      }

      .title {
        padding-top: 20px;
        font-size: 16px;
        text-align: center;
        position: relative;

        .icon-cuowu {
          position: absolute;
          right: 20px;
          color: #999;
        }
      }

      .sign-btns {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;

        .btn {
          display: inline-block;
          width: 40%;
          padding: 15px 0;
          border: 1px solid #eee;
          background: #e1e1e1;
          border-radius: 10px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  .ssearch {
    margin: 0.2667rem auto;

    .mianBox {
      margin: 0 auto;
      width: 150px !important;
      height: 35px;
      position: relative;
    }

    .leftBox,
    .rightBox {
      width: 90px !important;
    }

    .rightBox {
      left: 70px !important;
    }
  }

  .formTop {
    width: 100%;
    clear: both;
    position: fixed;
    z-index: 0;

    .topOne {
      height: 1.06666667rem;
      color: #fff;
      background-color: #f69c2d;
      text-align: center;
      line-height: 1.0133rem;
      float: left;
      font-size: 0.34666667rem;
      font-weight: bold;
      padding: 0;
    }
  }

  .formTopFix {
    position: fixed;
    top: 1.04rem;
    z-index: 200;
  }

  .ind {
    overflow-y: scroll;
    position: absolute;
    top: 365px + 1.04rem;
    bottom: 0;
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }

  .list {
    height: ~"calc(100vh - 4.88rem)";
    overflow: scroll;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 80px;

    .item {
      &:first-child {
        margin-top: -12px;
      }

      .detailed {
        width: 100%;
        margin: 12px auto 0;
        line-height: 14px;
        font-size: 12px;
        background-color: #fff;

        .top {
          padding: 6px 8px;
          border-bottom: 1px dashed #ddd;
          border-top: 3px solid #d2d6de;

          .left {
            float: left;
          }

          .right {
            float: right;

            span {
              color: #d0011b;
            }
          }
        }

        .content {
          position: relative;

          .info {
            color: #333;
            float: left;
            box-sizing: border-box;
            height: 22px;
            line-height: 22px;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            a {
            }
          }

          .info:nth-of-type(2n-1) {
            width: 50%;
            padding-left: 13px;
          }

          .info:nth-of-type(2n) {
            width: 50%;
          }

          .iconfont {
            position: absolute;
            right: 6px;
            top: ~"calc(50% - 6px)";
            color: #9b9b9b;
          }
        }
      }
    }
  }

  .list2 {
    height: ~"calc(100vh - 6rem)" !important;
    position: fixed;
    top: 70px !important;
  }

  .gttab {
    position: relative;
    margin-bottom: 1rem;

    .gtt {
      position: absolute;
      top: 0;
      left: 2.6rem;
      overflow: auto;
      width: 7.28rem;

      .gant {
        text-align: center;
        border-bottom: 1px solid #eaeaea;
        border-right: 1px solid #eaeaea;

        td {
          height: 1.1rem;
          border-top: 1px solid #eaeaea;
          border-left: 1px solid #eaeaea;
          box-sizing: border-box;
          font-size: 0.28rem;
          word-break: break-all;
          position: relative;
        }

        .h {
          height: 0.6rem;
        }

        .ttd {
          width: 6rem;
        }

        .std {
          width: 1.04rem;

          &:active {
            background: #eaeaea;
          }
        }

        .name {
          width: 1.04rem;
        }
      }
    }

    .tbl {
      position: absolute;
      border-bottom: 1px solid #eaeaea;
      border-right: 1px solid #eaeaea;
      top: 0;
      left: 0;
      text-align: center;

      td {
        height: 1.1rem;
        font-size: 0.28rem;
        width: 1.6rem;
        border-top: 1px solid #eaeaea;
        border-left: 1px solid #eaeaea;
        box-sizing: border-box;
        color: #666!important;
      }
    }
  }

  .tbl{
      color: #666!important;
  }

  tr:nth-of-type(2n) {
    background: #f5f5f5;
  }

  .spe-topd {
    width: 100%;
    overflow: hidden;
    position: fixed;
    top: 88px;
    border-bottom: 1px solid #eaeaea;
    .checkbox {
      display: inline-block;
      text-align: left;
      height: 0.6rem;
      line-height: 0.6rem;
      width: 1.65rem;
      font-size: 0.28rem;

      .dimetric {
        width: 0.33333333rem;
        height: 0.33333333rem;
        margin-right: 0.08rem;
        float: left;
        border-radius: 0.1rem;
        margin-top: 0.08rem;
        background: #fff;
      }
    }

    .left {
      float: left;
      width: 5rem;
    }

    .right {
      float: right;
      margin-right: 0.8rem;
      margin-bottom: 0.2rem;
    }

    .topr {
      position: relative;
      width: 100%;
      clear: both;
      height: 1.523rem;

      .tbl {
        background: #eee;
        position: absolute;
        left: 0;
        top: 0;
        border-bottom: 1px solid #eaeaea;
        border-right: 1px solid #eaeaea;
        text-align: center;

        td {
          height: 0.6rem;
          width: 1.04rem;
          border-top: 1px solid #eaeaea;
          border-left: 1px solid #eaeaea;
          box-sizing: border-box;
        }
      }

      .gtt {
        position: absolute;
        top: 0;
        left: 2.6rem;
        overflow: scroll;
        width: 7.28rem;

        .gant {
          text-align: center;
          border-bottom: 1px solid #eaeaea;
          border-right: 1px solid #eaeaea;
          background: #eee;

          td {
            height: 1.1rem;
            border-top: 1px solid #eaeaea;
            border-left: 1px solid #eaeaea;
            box-sizing: border-box;
          }

          .h {
            height: 1.5rem;
          }

          .ttd {
            width: 4.5rem;
          }

          .std {
            width: 1.04rem;
            color: #666;
            background-color: #fff;
            font-weight: bold;

            &:active {
              background: #eaeaea;
            }
          }

          .name {
            width: 1.04rem;
          }
        }
      }
    }
  }

  .firstLine{
    border-top: 4px solid #ccc;
  }
  .secondLine{
    border-top: 2px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// fangQList.vue?0fa86bc4